import { render, staticRenderFns } from "./LisProjectTableItem.vue?vue&type=template&id=66c4b943&scoped=true"
import script from "./LisProjectTableItem.vue?vue&type=script&lang=js"
export * from "./LisProjectTableItem.vue?vue&type=script&lang=js"
import style0 from "./LisProjectTableItem.vue?vue&type=style&index=0&id=66c4b943&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c4b943",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c4b943')) {
      api.createRecord('66c4b943', component.options)
    } else {
      api.reload('66c4b943', component.options)
    }
    module.hot.accept("./LisProjectTableItem.vue?vue&type=template&id=66c4b943&scoped=true", function () {
      api.rerender('66c4b943', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/lisProject/LisProjectTableItem.vue"
export default component.exports